import {inject, Injectable} from '@angular/core';
import {TranslocoLoader} from '@jsverse/transloco';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {DirectusService} from './directus.service';
import {Translation} from './models/translation';

interface TranslocoTranslationMap {
  [key: string]: string;
}

@Injectable({providedIn: 'root'})
export class DirectusTranslocoLoader implements TranslocoLoader {
  private directusService = inject(DirectusService);

  //https://selecthor.objectbay.cloud/directus-gateway/items/translations?filter[language][code][_eq]=de&limit=-1
  //https://selecthor.objectbay.cloud/directus-gateway/items/translations?filter=%7B%22language.code%22%3A%7B%22_eq%22%3A%22de%22%7D%7D&limit=-1
  //https://selecthor.objectbay.cloud/directus-gateway/items/translations?filter={"language.code":{"_eq":"de"}}&limit=-1
  getTranslation(lang: string): Observable<TranslocoTranslationMap> {
    return this.directusService.loadTranslations(lang).pipe(
      map((translationsArray: Translation[]) => {
        const translationMap: TranslocoTranslationMap = {};
        translationsArray.forEach((item: Translation) => {
          translationMap[item.key] = item.value;
        });
        return translationMap;
      }),
    );
  }
}
